import { observer } from 'mobx-react-lite'
import './settings.less'
import { Titles } from '../../layouts/Titles'
import { Row, Col, Input, Empty, theme } from 'antd'
import { useEffect, useMemo, useState } from 'react'
import i from '../../translations/i'
import { ErrorByPricingPlan } from '../../components/ErrorByPricingPlan'
import { storeLocal } from '../../helpers/stores'
import __schedule from './imports/__schedule'
import { config } from "../../config/app";
import userController from "../user/controllers/user.controller";
import { REVIEW_PLANS } from './reviews/reviewPlans'
import superController from '../super/super.controller'
import {
    SearchOutlined,
    SettingOutlined,
    MenuOutlined,
    ApiOutlined,
    CodeOutlined,
    RocketOutlined,
    GiftOutlined,
    UsergroupAddOutlined,
    ControlOutlined,
    CalendarOutlined,
    FormOutlined,
    ThunderboltOutlined,
    ExperimentOutlined,
    PictureOutlined,
    CreditCardOutlined,
    WalletOutlined,
    BankOutlined,
    FieldTimeOutlined,
    SplitCellsOutlined,
    EnvironmentOutlined,
    HomeOutlined,
    PushpinOutlined,
    TeamOutlined,
    BellOutlined,
    ImportOutlined,
    ScheduleOutlined,
    BarChartOutlined,
    ExportOutlined,
    TagsOutlined,
    LinkOutlined,
    GlobalOutlined,
    ShoppingCartOutlined,
    CarOutlined,
    TruckOutlined,
    ClockCircleOutlined,
    LockOutlined,
    SkinOutlined,
    StarOutlined,
    AppstoreOutlined,
    ToolOutlined,
    BgColorsOutlined,
} from '@ant-design/icons'

export const Settings = observer(() => {

    const { token } = theme.useToken()
    const [search, setSearch] = useState('')

    useEffect(() => {
        __schedule.get()
        superController.check()
    }, [])

    let navigation: any[] = [
        {
            label: i.t('settings:hub.groups.project'),
            items: [
                {
                    icon: <SettingOutlined />,
                    label: i.t('settings:project.title'),
                    hint: i.t('settings:hub.hints.project'),
                    href: `/settings/project`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <BellOutlined />,
                    label: i.t('settings:notifications.title'),
                    hint: i.t('settings:hub.hints.notifications'),
                    href: `/settings/notifications`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <TeamOutlined />,
                    label: i.t('def:managers.list'),
                    hint: i.t('settings:hub.hints.managers'),
                    href: `/settings/managers`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <FormOutlined />,
                    label: i.t('def:Additional fields'),
                    hint: i.t('settings:hub.hints.additionalFields'),
                    href: `/settings/additional_fields`,
                    visible: true,
                    plan: 1,
                    black_mark: storeLocal.get('black_mark')
                },
            ],
        },
        {
            label: i.t('settings:hub.groups.storefront'),
            items: [
                {
                    icon: <MenuOutlined />,
                    label: i.t('nav:nav'),
                    hint: i.t('settings:hub.hints.navigation'),
                    href: `/settings/navigation`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <RocketOutlined />,
                    label: i.t('nav:onBoarding'),
                    hint: i.t('settings:hub.hints.onBoarding'),
                    href: `/settings/onboarding`,
                    visible: true,
                    plan: 1,
                },
                {
                    icon: <BgColorsOutlined />,
                    label: i.t('settings:appThemes.title'),
                    hint: i.t('settings:hub.hints.appThemes'),
                    href: `/settings/themes`,
                    visible: true,
                    plan: 0,
                },
            ],
        },
        {
            label: i.t('settings:hub.groups.catalog'),
            items: [
                {
                    icon: <ImportOutlined />,
                    label: i.t('def:importCatalog'),
                    hint: i.t('settings:hub.hints.importCatalog'),
                    href: `/settings/import`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <ScheduleOutlined />,
                    label: i.t('settings:import.settings'),
                    hint: i.t('settings:hub.hints.importSchedule'),
                    href: `/settings/import/schedule`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <BarChartOutlined />,
                    label: i.t('settings:sbis.last'),
                    hint: i.t('settings:hub.hints.importStat'),
                    href: `/settings/import/stat`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <ExportOutlined />,
                    label: i.t('def:Export settings'),
                    hint: i.t('settings:hub.hints.exportSettings'),
                    href: `/settings/export`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <TagsOutlined />,
                    label: i.t('def:Price types'),
                    hint: i.t('settings:hub.hints.priceTypes'),
                    href: `/settings/price_types`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <LinkOutlined />,
                    label: i.t('relatedBulk:title'),
                    hint: i.t('settings:hub.hints.relatedBulk'),
                    href: `/catalog/related-bulk`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <PictureOutlined />,
                    label: i.t('defaultPictures:title'),
                    hint: i.t('settings:hub.hints.defaultPictures'),
                    href: `/settings/default_pictures`,
                    visible: true,
                    plan: 1,
                    black_mark: storeLocal.get('black_mark')
                },
                {
                    icon: <ControlOutlined />,
                    label: i.t('def:Quantity control list'),
                    hint: i.t('settings:hub.hints.quantityControl'),
                    href: `/settings/quantity_control`,
                    visible: true,
                    plan: 2,
                    black_mark: storeLocal.get('black_mark')
                },
            ]
        },
        {
            label: i.t('settings:hub.groups.site'),
            items: [
                {
                    icon: <SkinOutlined />,
                    label: i.t('settings:hub.labels.webSettings'),
                    hint: i.t('settings:hub.hints.webSettings'),
                    href: `/web_settings`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <GlobalOutlined />,
                    label: i.t('settings:seoFiles.title'),
                    hint: i.t('settings:hub.hints.seoFiles'),
                    href: `/settings/seo_files`,
                    visible: true,
                    plan: 0,
                },
                // Домен магазина настраивает только администратор проекта (роль 0 в хранилище не записывается).
                // visible тут учитывается лишь при поиске, поэтому плитку для остальных ролей не добавляем вовсе
                ...(!storeLocal.get('role') ? [{
                    icon: <LinkOutlined />,
                    label: i.t('domain:title'),
                    hint: i.t('domain:hint'),
                    href: `/settings/domain`,
                    visible: true,
                    plan: 0,
                }] : []),
            ]
        },
        {
            label: i.t('settings:hub.groups.locations'),
            items: [
                {
                    icon: <EnvironmentOutlined />,
                    label: i.t('settings:cities.title'),
                    hint: i.t('settings:hub.hints.cities'),
                    href: `/settings/cities` ,
                    visible: true,
                    plan: 2,
                },
                {
                    icon: <HomeOutlined />,
                    label: i.t('settings:storage.title'),
                    hint: i.t('settings:hub.hints.warehouses'),
                    href: `/settings/warehouses`,
                    visible: true,
                    plan: 2,
                },
                {
                    icon: <PushpinOutlined />,
                    label: i.t('nav:places'),
                    hint: i.t('settings:hub.hints.places'),
                    href: `/settings/places`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <CalendarOutlined />,
                    label: i.t('def:Calendars'),
                    hint: i.t('settings:hub.hints.calendars'),
                    href: `/settings/calendars`,
                    visible: true,
                    plan: 1,
                    black_mark: storeLocal.get('black_mark')
                },
            ]
        },
        {
            label: i.t('settings:hub.groups.orders'),
            items: [
                {
                    icon: <ShoppingCartOutlined />,
                    label: i.t('settings:order.title'),
                    hint: i.t('settings:hub.hints.ordersSettings'),
                    href: `/settings/orders`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <CarOutlined />,
                    label: i.t('def:Roadmap'),
                    hint: i.t('settings:hub.hints.roadmap'),
                    href: `/settings/roadmap`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <TruckOutlined />,
                    label: i.t('settings:delivery.base.title'),
                    hint: i.t('settings:hub.hints.deliveryBase'),
                    href: `/settings/delivery/base`,
                    visible: true,
                    plan: 0
                },
                {
                    icon: <ClockCircleOutlined />,
                    label: i.t('settings:delivery.intervals.title'),
                    hint: i.t('settings:hub.hints.deliveryIntervals'),
                    href: `/settings/delivery_intervals`,
                    visible: true,
                    plan: 0
                },
                {
                    icon: <EnvironmentOutlined />,
                    label: i.t('settings:delivery.zones.title'),
                    hint: i.t('settings:hub.hints.deliveryZones'),
                    href: `/settings/delivery/zones`,
                    visible: true,
                    plan: 0
                },
                {
                    icon: <ThunderboltOutlined />,
                    label: i.t('loadManagement:title'),
                    hint: i.t('settings:hub.hints.loadManagement'),
                    href: `/settings/load_management`,
                    visible: true,
                    plan: 1,
                    black_mark: storeLocal.get('black_mark')
                },
            ]
        },
        {
            label: i.t('settings:hub.groups.payment'),
            items: [
                {
                    icon: <CreditCardOutlined />,
                    label: i.t('payment:types.title'),
                    hint: i.t('settings:hub.hints.paymentTypesShop'),
                    href: `/shop/payment/types`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <WalletOutlined />,
                    label: i.t('def:Payment types'),
                    hint: i.t('settings:hub.hints.paymentTypes'),
                    href: `/settings/payment_types`,
                    visible: config.shortServiceName !== 'b2c',
                    plan: 0,
                    black_mark: storeLocal.get('black_mark')
                },
                {
                    icon: <BankOutlined />,
                    label: i.t('def:Payment gateway list'),
                    hint: i.t('settings:hub.hints.paymentGateway'),
                    href: `/settings/payment_gateway`,
                    visible: config.shortServiceName !== 'b2c',
                    plan: 0,
                    black_mark: storeLocal.get('black_mark')
                },
                {
                    icon: <FieldTimeOutlined />,
                    label: i.t('settings:deferredPayment'),
                    hint: i.t('settings:hub.hints.paymentOptions'),
                    href: `/settings/payment/options`,
                    visible: config.shortServiceName !== 'b2c',
                    plan: 0,
                    black_mark: storeLocal.get('black_mark')
                },
                {
                    icon: <SplitCellsOutlined />,
                    label: i.t('paymentOptions:splitPayments'),
                    hint: i.t('settings:hub.hints.paymentSplit'),
                    href: `/settings/payment/split`,
                    visible: config.shortServiceName !== 'b2c',
                    plan: 0,
                    black_mark: storeLocal.get('black_mark')
                },
            ],
        },
        {
            label: i.t('settings:hub.groups.loyalty'),
            items: [
                {
                    icon: <GiftOutlined />,
                    label: i.t('nav:bonus_program'),
                    hint: i.t('settings:hub.hints.bonusProgram'),
                    href: `/settings/bonus_program`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <UsergroupAddOutlined />,
                    label: i.t('def:Referral system'),
                    hint: i.t('settings:hub.hints.referral'),
                    module: userController.isModule(11),
                    visible: true,
                    href: `/settings/referral`,
                    plan: config.shortServiceName === 'b2c' ? 2 : 3,
                    black_mark: storeLocal.get('black_mark')
                },
                {
                    icon: <StarOutlined />,
                    label: i.t('reviews:settings.title'),
                    hint: i.t('settings:hub.hints.reviews'),
                    href: `/settings/reviews`,
                    visible: true,
                    plan: REVIEW_PLANS.order,
                },
            ],
        },
        {
            label: i.t('settings:hub.groups.integrations'),
            items: [
                {
                    icon: <ApiOutlined />,
                    label: i.t('nav:integrations'),
                    hint: i.t('settings:hub.hints.integrations'),
                    href: `/settings/integrations`,
                    visible: true,
                    plan: 2,
                    black_mark: storeLocal.get('black_mark')
                },
                {
                    icon: <CodeOutlined />,
                    label: i.t('nav:rest'),
                    hint: i.t('settings:hub.hints.rest'),
                    href: `/settings/rest`,
                    visible: true,
                    plan: 3,
                    black_mark: storeLocal.get('black_mark')
                },
            ],
        },
    ]

    // Бывшая суперадминка старого API — только суперпользователю (сервер проверяет сам)
    if (superController.isSuper) {
        navigation.push({
            label: i.t('superAdmin:hub.group'),
            items: [
                {
                    icon: <AppstoreOutlined />,
                    label: i.t('superAdmin:hub.projects'),
                    hint: i.t('superAdmin:hub.projectsHint'),
                    href: `/super/projects`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <ToolOutlined />,
                    label: i.t('superAdmin:hub.fields'),
                    hint: i.t('superAdmin:hub.fieldsHint'),
                    href: `/super/fields`,
                    visible: true,
                    plan: 0,
                },
                {
                    icon: <ExperimentOutlined />,
                    label: i.t('superAdmin:hub.features'),
                    hint: i.t('superAdmin:hub.featuresHint'),
                    href: `/super/features`,
                    visible: true,
                    plan: 0,
                },
            ],
        })
    }

    const query = search.trim().toLowerCase()

    const filteredNavigation = useMemo(() => {
        if (!query) return navigation

        return navigation
            .map(group => ({
                ...group,
                items: group.items.filter((item: any) =>
                    item.visible && (
                        item.label.toLowerCase().includes(query) ||
                        (item.hint ?? '').toLowerCase().includes(query)
                    )
                )
            }))
            .filter(group => group.items.length > 0)
    }, [query, navigation])

    const hasResults = filteredNavigation.some(group => group.items.length > 0)

    return(
        <>
            <Titles
                title={i.t('def:settings')}
                breadcrumb={[ { title: i.t('def:settings') } ]}
            />

            <Row style={{ marginBottom: 40 }}>
                <Col xs={24} md={12} lg={8}>
                    <Input
                        size="large"
                        allowClear
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        placeholder={i.t('settings:hub.search')}
                        prefix={<SearchOutlined style={{ color: token.colorTextTertiary, marginRight: 4 }} />}
                        style={{ borderRadius: 999, padding: '10px 20px' }}
                    />
                </Col>
            </Row>

            {!hasResults ? (
                <Empty description={i.t('settings:hub.noResults')} style={{ margin: '60px 0' }} />
            ) : (
                <Row gutter={[32, 48]}>
                    {filteredNavigation.map((el, groupIndex) => (
                        <Col xs={24} lg={12} key={`settings_group_${groupIndex}`}>
                            <div style={{ fontSize: 13, fontWeight: 600, letterSpacing: 0.4, textTransform: 'uppercase', color: token.colorTextTertiary, marginBottom: 12, paddingLeft: 4 }}>
                                {el.label}
                            </div>
                            <div
                                style={{
                                    background: token.colorBgContainer,
                                    border: `1px solid ${token.colorBorderSecondary}`,
                                    borderRadius: 16,
                                }}
                            >
                                {el.items.map((item: any, itemIndex: number) => {
                                    const disabled = item.module ? false : (storeLocal.get('pricing_plan') < item.plan || !!item.black_mark)

                                    return (
                                        <ErrorByPricingPlan
                                            key={`settings_item_${groupIndex}_${itemIndex}`}
                                            plan={item.module ? 0 : item.plan}
                                            black_mark={item.black_mark ?? false}
                                            content={
                                                <a
                                                    href={disabled ? undefined : item.href}
                                                    className={`settings-hub-item${disabled ? ' settings-hub-item--disabled' : ''}`}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        gap: 16,
                                                        padding: '16px 20px',
                                                        borderTop: itemIndex === 0 ? 'none' : `1px solid ${token.colorBorderSecondary}`,
                                                        cursor: disabled ? 'not-allowed' : 'pointer',
                                                        color: disabled ? token.colorTextDisabled : token.colorText,
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            width: 38,
                                                            height: 38,
                                                            flex: '0 0 auto',
                                                            borderRadius: 10,
                                                            fontSize: 17,
                                                            background: disabled ? token.colorFillTertiary : token.colorPrimaryBg,
                                                            color: disabled ? token.colorTextDisabled : token.colorPrimary,
                                                        }}
                                                    >
                                                        {item.icon}
                                                    </div>
                                                    <div style={{ flex: '1 1 auto', minWidth: 0, paddingTop: 2 }}>
                                                        <div style={{ fontSize: 15, fontWeight: 500, lineHeight: 1.3 }}>
                                                            {item.label}
                                                        </div>
                                                        {item.hint && (
                                                            <div style={{ fontSize: 13, color: token.colorTextTertiary, marginTop: 3, lineHeight: 1.4 }}>
                                                                {item.hint}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {disabled && (
                                                        <LockOutlined style={{ flex: '0 0 auto', color: token.colorTextTertiary, marginTop: 10, fontSize: 13 }} />
                                                    )}
                                                </a>
                                            }
                                        />
                                    )
                                })}
                            </div>
                        </Col>
                    ))}
                </Row>
            )}
        </>
    )
})
